module.exports = __webpack_public_path__ + "5e2bd8b319d3c5800139a3a4cda1e049.png";